<template>
  <el-dialog :title="$t('addAServMenu.add')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="addAServMenuInfo" label-width="120px">
      <el-form-item :label="$t('addAServMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('addAServMenu.menuNameRequired') }]">
        <el-input v-model="addAServMenuInfo.hktName" :placeholder="$t('addAServMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('addAServMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('addAServMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('addAServMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="addAServMenuInfo.hktDesc" :placeholder="$t('addAServMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('addAServMenu.label')" prop="label">
        <el-input v-model="addAServMenuInfo.label" :placeholder="$t('addAServMenu.inputLabel')" />
      </el-form-item>
      <el-form-item :label="$t('addAServMenu.selectServ')" required>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="shopId" :rules="[{ required: true, message: $t('addAServMenu.shopRequired') }]">
              <el-select v-model="addAServMenuInfo.shopId" :placeholder="$t('addAServMenu.selectShop')"
                style="width:100%" @change="queryAShopServs">
                <el-option :label="$t('addAServMenu.selectShop')" value="" />
                <el-option v-for="shop in addAServMenuInfo.shops" :key="shop.shopId" :label="shop.shopName"
                  :value="shop.shopId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="servId" :rules="[{ required: true, message: $t('addAServMenu.servRequired') }]">
              <el-select v-model="addAServMenuInfo.servId" :placeholder="$t('addAServMenu.selectServ')"
                style="width:100%">
                <el-option :label="$t('addAServMenu.selectServ')" value="" />
                <el-option v-for="serv in addAServMenuInfo.servs" :key="serv.servId" :label="serv.servName"
                  :value="serv.servId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item :label="$t('addAServMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('addAServMenu.sortRequired') }]">
        <el-input v-model="addAServMenuInfo.seq" :placeholder="$t('addAServMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('addAServMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('addAServMenu.showStatusRequired') }]">
        <el-select v-model="addAServMenuInfo.isShow" :placeholder="$t('addAServMenu.selectShowStatus')"
          style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveAddAServMenuInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveProductMenu, queryShopsByAdmin, queryAdminServ } from '@/api/admin/shopProductType/shopProductTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'AddAServMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      addAServMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '1',
        isShow: '',
        typeCd: '2002',
        shopId: '',
        shops: [],
        servs: [],
        servId: ''
      }
    }
  },
  methods: {
    open(data = {}) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.addAServMenuInfo = {
          ...this.addAServMenuInfo,
          ...data
        }
        if (data.hktIcon) {
          this.$refs.uploadImage.setImages([data.hktIcon])
        } else {
          this.$refs.uploadImage.clearImages()
        }
        this.loadShops()
      })
    },
    async loadShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.addAServMenuInfo.shops = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async queryAShopServs() {
      if (!this.addAServMenuInfo.shopId) return

      try {
        const res = await queryAdminServ({
          page: 1,
          row: 500,
          shopId: this.addAServMenuInfo.shopId
        })
        this.addAServMenuInfo.servs = res.data
        this.addAServMenuInfo.servId = ''
      } catch (error) {
        console.error(error)
      }
    },
    handleUploadImage(photos) {
      this.addAServMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveAddAServMenuInfo() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.addAServMenuInfo.url = `/pages/homemaking/detail?servId=${this.addAServMenuInfo.servId}&shopId=${this.addAServMenuInfo.shopId}`

        await saveProductMenu(this.addAServMenuInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>